export default {
    KSIM: 'KSIM Support',
    LIFE_CALCULATOR: 'Aluminum Life Calculator Support',
    DATASHEET: 'Datasheet',
    STEP: 'STEP'
};
